import { passCodes } from '../passCodes';
import audio from '../../../../assets/audio/kids-tracks/Text14.mp3';

export const step15talk = {
    id: 15,
    title: 'Vyšetřování',
    taskText: `
        <p>
            Pokud jsi si vzpomněl alespoň na 4, tak jsi velký šikula! Ale my žádný z nich teď nevyužijeme. 
            Pořád jsme totiž nepřišli na to, proč je Zelená hora zelená. Nějak nám to vyšetřování nejde. 
            Co takhle si trošku procvičit přemýšlení a hledání? Určitě se nám to ještě dneska bude hodit.
        </p>
    `,
    cipher: {
        text: `
            <p>
                Kolik tu v okolí vidíme laviček?
            </p>
            <ol type="a">
                <li>1</li>
                <li>2</li>
                <li>3</li>
            </ol>
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[3],
    additionalInfo: 'Odpovědí je písmeno a/b/c',
    points: false,
    audio: audio,
    hints: [
        {
            text: 'Lavičky jsou 3',
        },
    ],
};
